<template>
    <div class='page_container' :style="{
        height: `${windowHeight}px`
    }">
        <PageHeader />
        <div class="page_body">
            <el-row :gutter="10">
                <el-col :span="4">
                    <div class="page_module page_module--bg h-small">
                        <div class="page_module-title mb-15">累计监管资金</div>
                        <div class="price-font price-color mb-25">12,546,325.25</div>
                        <div class="page_module-subtitle mb-10">监管账户</div>
                        <div class="page_module-title p-l-20">{{totalCount}} 个</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="page_module page_module--bg h-small">
                        <div class="page_module-title mb-15">累计资金出账</div>
                        <div class="price-font price-color mb-25">7,286,735.05</div>
                        <el-row>
                            <el-col :span="8">
                                <div class="page_module-subtitle mb-10">Top1</div>
                                <div class="page_module-subtitle text-ellipsis" :title="top1Name">{{ top1Name }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="page_module-subtitle mb-10">Top2</div>
                                <div class="page_module-subtitle text-ellipsis" :title="top2Name">{{ top2Name }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="page_module-subtitle mb-10">Top3</div>
                                <div class="page_module-subtitle text-ellipsis" :title="top3Name">{{ top3Name }}</div>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="page_module page_module--bg h-small">
                        <div class="page_module-title mb-15">今日资金入账</div>
                        <div class="price-font price-color mb-25">0.00万</div>
                        <el-row>
                            <el-col :span="8">
                                <div class="page_module-subtitle mb-10">Top1</div>
                                <div class="page_module-subtitle text-ellipsis" :title="top1Name">{{ top1Name }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="page_module-subtitle mb-10">Top2</div>
                                <div class="page_module-subtitle text-ellipsis" :title="top2Name">{{ top2Name }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="page_module-subtitle mb-10">Top3</div>
                                <div class="page_module-subtitle text-ellipsis" :title="top3Name">{{ top3Name }}</div>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="page_module page_module--bg h-small">
                        <div class="page_module-title mb-15">今日资金出账</div>
                        <div class="price-font price-color mb-25">0.00万</div>
                        <div class="page_module-subtitle mb-10">首次25%出账</div>
                        <div class="page_module-title price-color">0笔 0.00万</div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="page_module page_module--bg h-small">
                        <div class="page_module-title mb-15">年度资金出账</div>
                        <div class="flex-box flex-between">
                            <div>
                                <span class="price-font price-color">36</span>
                                <span class="page_module-title p-l-10">笔</span>
                            </div>
                            <span class="page_module-subtitle">12.50%</span>
                        </div>
                        <div ref="echarts1" style="height: 100px;"></div>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="8">
                    <div class="page_module h-middle">
                        <div class="flex-box">
                            <div class="flex-box flex-center" style="height: 100px; width: 200px;">
                                <el-progress type="circle"
                                    :percentage="90"
                                    :width="90"
                                    :stroke-width="6"
                                    color="#C1975A"
                                    define-back-color="red">
                                </el-progress>
                            </div>
                            <div class="p-l-20">
                                <div class="page_module-title mb-15">今日实时账户总余额</div>
                                <div class="price-font price-color">￥5,259,590.20</div>
                            </div>
                        </div>
                        <div ref="echarts2" style="height: 130px;"></div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="page_module page_module--bg h-middle">
                        <div ref="echarts3" style="height: 230px;"></div>
                    </div>
                </el-col>
                <el-col :span="10">
                    <div class="page_module page_module--bg h-middle">
                        <div ref="echarts4" style="height: 230px;"></div>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="8">
                    <div class="page_module h-large">
                        <el-table :data='submerhList' style='width: 100%' stripe>
                            <el-table-column prop='schoolName' label='学校名称'
                                min-width="120"
                                show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label='上一年度结余'
                                min-width="80">
                                <span class="price-color">0</span>
                            </el-table-column>
                            <el-table-column label='入账'
                                min-width="80">
                                <template slot-scope="{row}">
                                    <span class="price-color">{{ row.revenuetotal }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label='出账'
                                min-width="80">
                                <template slot-scope="{row}">
                                    <span class="price-color">{{ row.withdtotal }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label='实时剩余'
                                min-width="80">
                                <template slot-scope="{row}">
                                    <span class="price-color">{{ row.balance }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="page_module h-large">
                        <el-table :data='approvalData' style='width: 100%' stripe>
                            <el-table-column label='学校'
                                show-overflow-tooltip
                                min-width="100">
                                <template slot-scope="{row}">
                                    <span @click="handleApprovalInfo(row)">{{ row.schoolName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop='name' label='类型'>
                                <template slot-scope="{row}">
                                    <span v-if="row.type === 1" class="price-color">25%资金出账</span>
                                    <span v-else-if="row.type === 2" class="price-color">收费项目</span>
                                    <span v-else-if="row.type === 3" class="price-color">剩余资金出账</span>
                                </template>
                            </el-table-column>
                            <el-table-column label='金额' width="120">
                                <template slot-scope="{row}">
                                    <span class="price-color" @click="handleApprovalInfo(row)">￥{{ row.amount }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label='用途'
                                show-overflow-tooltip
                                min-width="180">
                                <template slot-scope="{row}">
                                    <span class="price-color" @click="handleApprovalInfo(row)">{{ row.useInfo }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="page_module h-large">
                        <div class="page_module--bg page_module-title" style="padding: 10px 15px;">
                            预警播报
                        </div>
                        <div style="height: 284px; overflow: hidden;">
                            <seamless-scroll :data="warningNoticeData" :class-option="options">
                                <el-table :data='warningNoticeData'
                                    style='width: 100%; height: 284px;'
                                    :show-header="false">
                                    <el-table-column show-overflow-tooltip>
                                        <template slot-scope="{row}">
                                            <img class="warning-icon" src="http://cdnfile-10043692.cos.ap-shanghai.myqcloud.com/admin/images/iPayment/warningIcon.png" alt="">
                                            <span class="danger-color">{{ row.title }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column width="120" prop='date'>
                                        <template slot-scope="{row}">
                                            <span class="danger-color">{{ row.date }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </seamless-scroll>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import echarts from 'echarts'
import seamlessScroll from 'vue-seamless-scroll'
import PageHeader from './components/Header'
import windowResize from '@/mixins/windowResize';
import { querySubmerhListByMerId } from '@/api/platformmerchant';
import { getFundApplyListByEduBatch } from '@/api/iPayment/homePage'
export default {
    components: {
        PageHeader,
        seamlessScroll
    },
    mixins: [windowResize],
    data() {
        return {
            echartsInstance1: null,
            echartsInstance2: null,
            echartsInstance3: null,
            echartsInstance4: null,
            warningNoticeData: [
                {
                    title: '南京信息工程大学附属中学 监管账户余额已低于阈值',
                    date: '2023-09-26'
                },
                {
                    title: '南京市栖霞区龙潭幼儿园 存在大额出金',
                    date: '2023-09-17'
                },
                {
                    title: '南京市银龙鑫苑幼儿园 监管账户余额已低于阈值',
                    date: '2023-09-16'
                },
                {
                    title: '南京戏墨娃文化传播有限公司 监管账户变更',
                    date: '2023-09-14'
                },
                {
                    title: '南京信息工程大学附属中学 存在大额出金',
                    date: '2023-09-14'
                },
                {
                    title: '南京市银龙鑫苑幼儿园 监管账户余额已低于25%',
                    date: '2023-09-14'
                }
            ],
            approvalData: [],
            submerhList: [],
            totalCount: 0,
            options: {
                step: 0.5,
                limitMoveNum: 1,
                autoPlay: true
            }
        }
    },
    computed: {
        top1Name() {
            const data = this.submerhList[0] || {}
            return data.schoolName || '--'
        },
        top2Name() {
            const data = this.submerhList[1] || {}
            return data.schoolName || '--'
        },
        top3Name() {
            const data = this.submerhList[2] || {}
            return data.schoolName || '--'
        }
    },
    mounted() {
        this.initEcharts1()
        this.initEcharts2()
        this.initEcharts3()
        this.initEcharts4()
        this.getSubmerhList()
        this.getApprovalData()
    },
    methods: {
        handleApprovalInfo(row) {
            // if(row.type==1){
            //      this.$router.push({
            //         path: "/main/newiPayment/fundApplicationApproval/fundApplicationApprovalInfo",
            //         query: {id:row.id}
            //     });
            // }else{
            //     this.$router.push({
            //         path: "/main/newiPayment/fundApplicationApproval/fundApplicationApprovalInfo",
            //         query: {id:row.id}
            //     });
            // }
        },
        async getApprovalData() {
            try {
                const queryList = {
                    applyState: 1, // 已审批
                    pageSize: 6
                }
                const { data: { data }} = await getFundApplyListByEduBatch(queryList)
                this.approvalData = data.dataList.map(i => {
                    i.amount = i.amount / 100
                    return i
                })
            } catch (err) {
                console.log(err)
            }
        },
        async getSubmerhList() {
            try {
                const queryList = {
                    merId: '103881013982881',
                    pageNo: 1,
                    pageSize: 10,
                    searchVal: ''
                }
                const { data: { data }} = await querySubmerhListByMerId(queryList)
                this.submerhList = data.dataList
                this.totalCount = data.pagination.total
            } catch (err) {
                console.log(err)
            }
        },
        initEcharts1() {
            this.echartsInstance1 = echarts.init(
                this.$refs.echarts1
            );
            this.echartsInstance1.setOption({
                grid: {
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%'
                },
                xAxis: {
                    type: 'category',
                    show: false
                },
                yAxis: {
                    type: 'value',
                    show: false
                },
                series: [
                    {
                        data: [150, 230, 224, 218, 135, 147, 260, 130, 220, 180],
                        type: 'line',
                        itemStyle: {
                            color: '#C1975A',
                            borderWidth: 4
                        },
                        lineStyle: {
                            color: '#fff'
                        }
                    }
                ]
            })
        },
        initEcharts2() {
            this.echartsInstance2 = echarts.init(
                this.$refs.echarts2
            );
            this.echartsInstance2.setOption({
                grid: {
                    top: 0,
                    left: -20,
                    right: -20,
                    height: '100%'
                },
                xAxis: {
                    type: 'category',
                    show: false
                },
                yAxis: {
                    type: 'value',
                    show: false
                },
                series: [
                    {
                        data: [150, 230, 224, 218, 135, 147, 260, 130, 220, 180],
                        type: 'line',
                        itemStyle: {
                            opacity: 0
                        },
                        areaStyle: {
                            color: '#3D4255'
                        },
                        lineStyle: {
                            color: '#fff'
                        }
                    }
                ]
            })
        },
        initEcharts3() {
            this.echartsInstance3 = echarts.init(
                this.$refs.echarts3
            );
            this.echartsInstance3.setOption({
                radar: {
                    shape: 'circle',
                    indicator: [
                        { name: '学费', max: 6500 },
                        { name: '伙食费', max: 16000 },
                        { name: '学杂费', max: 30000 },
                        { name: '住宿费', max: 38000 },
                        { name: '其它', max: 25000 }
                    ]
                },
                series: [
                    {
                        name: 'Budget vs spending',
                        type: 'radar',
                        areaStyle: {
                            color: '#C1975A',
                            opacity: 0.4
                        },
                        data: [
                            {
                                value: [4200, 3000, 20000, 35000, 18000],
                                name: 'Allocated Budget',
                                itemStyle: {
                                    color: '#C1975A'
                                }
                            },
                        ]
                    }
                ]
            })
        },
        initEcharts4() {
            this.echartsInstance4 = echarts.init(
                this.$refs.echarts4
            );
            const dateArr = []
            const now = Date.now()
            for (let i = 0; i < 7; i++) {
                const day = now - (1000 * 60 * 60 * 24 * i)
                dateArr.unshift(moment(new Date(day)).format('MM/DD'))
            }
            this.echartsInstance4.setOption({
                title: {
                    text: '近七日资金情况',
                    align: 'center',
                    left: 'center',
                    textStyle: {
                        fontSize: 20,
                        color: '#fff'
                    }
                },
                grid: {
                    left: '5%',
                    right: '4%',
                    bottom: '10%',
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: dateArr,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    splitLine: {
                        show: true
                    },
                    axisLabel: {
                        color: '#fff'
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisLabel: {
                        color: '#fff'
                    }
                },
                series: [
                    {
                        name: 'Email',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        areaStyle: {
                            color: '#F08733',
                            opacity: 1
                        },
                        itemStyle: {
                            color: '#F08733',
                            opacity: 0
                        },
                        data: [120, 132, 101, 134, 90, 230, 210]
                    },
                    {
                        name: 'Union Ads',
                        type: 'line',
                        stack: 'Total',
                        smooth: true,
                        areaStyle: {
                            color: '#F5AF3F',
                            opacity: 1
                        },
                        itemStyle: {
                            color: '#F5AF3F',
                            opacity: 0
                        },
                        data: [220, 182, 191, 234, 290, 330, 310]
                    }
                ]
            })
        }
    }
}
</script>

<style lang='scss' scoped>
@import "~@/styles/mixin";
@import "./style.scss";
.page_container {
    overflow: auto;
    background-color: #22273B;
}
.page_body {
    width: 1920px;
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden;
}
.page_module {
    padding: 15px 15px;
    border-radius: 4px;
    box-sizing: border-box;
    // background-color: pink;
    color: #fff;
    .page_module-title {
        font-size: 20px;
    }
    .page_module-subtitle {
        font-size: 14px;
    }
    &--bg {
        background-color: #2D3447;
    }
}

.el-row+.el-row {
    margin-top: 10px;
}
.warning-icon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
}
/deep/.el-progress .el-progress__text {
    font-size: 22px!important;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/iPayment/cockpitHome/index.vue